import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import PersonaBenefits from './components/PersonaBenefits';
import Pricing from './components/Pricing';
import ROICalculator from './components/ROICalculator';
import FeaturesGrid from './components/FeaturesGrid';
import FAQ from './components/FAQ';
import SocialProof from './components/SocialProof';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import SEO from './components/SEO';
export function App() {
  return <HelmetProvider data-id="element-0">
      <div className="font-inter text-charcoal" data-id="element-1">
        <SEO data-id="element-2" />
        <Navbar data-id="element-3" />
        <Hero data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <PersonaBenefits data-id="element-7" />
        <Pricing data-id="element-8" />
        <ROICalculator data-id="element-9" />
        <FeaturesGrid data-id="element-10" />
        <FAQ data-id="element-11" />
        <SocialProof data-id="element-12" />
        <FinalCTA data-id="element-13" />
        <Footer data-id="element-14" />
      </div>
    </HelmetProvider>;
}